export default __webpack_public_path__ + "static/media/reply icon.217fe6a6.svg";